/**
 * 本から TODO を作るフォーマットの置き換え。
 *
 * `{title}` `{author}` `{publisher}` `{isbn}` を本の値に置き換える。
 * 値が無いものは空にし、知らない `{xxx}` はそのまま残す（打ち間違いに気づけるように）。
 */

import type { TodoBookTemplate } from '@/api/types/todo-book-template'

export const DEFAULT_BOOK_TODO_FORMAT = '{title}を読む'

export type BookTodoFields = {
  title: string
  author?: string | null
  publisher?: string | null
  isbn?: string | null
}

export const BOOK_TODO_PLACEHOLDERS = [
  { key: '{title}', label: '書名' },
  { key: '{author}', label: '著者' },
  { key: '{publisher}', label: '出版社' },
  { key: '{isbn}', label: 'ISBN' },
] as const

/** TODO を作るときに使うフォーマット。id が null なら保存されていない既定のもの */
export type BookTodoFormat = {
  id: number | null
  format: string
  project: string | null
}

const fieldValue = (name: string, fields: BookTodoFields): string | null => {
  switch (name) {
    case 'title':
      return fields.title
    case 'author':
      return fields.author ?? ''
    case 'publisher':
      return fields.publisher ?? ''
    case 'isbn':
      return fields.isbn ?? ''
    default:
      return null
  }
}

export const renderBookTodoTitle = (format: string, fields: BookTodoFields): string =>
  format.replace(/\{([a-z]+)\}/g, (match, name: string) => fieldValue(name, fields) ?? match).trim()

/** 保存済みのフォーマットが無ければ「{title}を読む」を既定で使う */
export const effectiveBookTodoFormats = (templates: TodoBookTemplate[]): BookTodoFormat[] =>
  templates.length === 0
    ? [{ id: null, format: DEFAULT_BOOK_TODO_FORMAT, project: null }]
    : templates.map(({ id, format, project }) => ({ id, format, project }))
